import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormGroup, FormGroupDirective, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonBindingDataService } from '../../../services/common-binding-data.service';
import { CalendarModule } from 'primeng/calendar';
import { DeviceDetectionService } from 'app/modules/shared/services/device-detection.service';
import { MetaDataService } from 'app/modules/shared/services/meta-data.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-date-range',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, CalendarModule, TranslateModule],
  templateUrl: './date-range.component.html',
  styleUrl: './date-range.component.scss'
})
export class DateRangeComponent implements OnInit {
  @Output() onSelectedDate: EventEmitter<any> = new EventEmitter();
  @Input() field: any;
  formName: FormGroup;
  @Input() attributeLabels: [];
  @Input() moduleName: string;
  placeholder: any;
  rangeDates: Date[] | undefined;
  isTouchDevice: boolean = false;
  maxDate: Date;

  constructor(private formGroupDirective: FormGroupDirective,
    public cs: CommonBindingDataService,
    private metaDataService: MetaDataService,
    private deviceDetectionService: DeviceDetectionService,) {
    this.formName = this.formGroupDirective.control;
  }

  ngOnInit(): void {
    this.placeholder = this.cs.getLabelValue(`${this.moduleName}.fields.${this.field.attributeCode}.placeholder`, this.attributeLabels, null);
    this.placeholder = this.placeholder ? this.placeholder : this.cs.getLabel('lbl_select_date')
    this.isTouchDevice = this.deviceDetectionService.isTouchDevice();

    // Set maxDate conditionally based on field configuration
    if (this.field?.restrictToToday) {
      const today = new Date();
      today.setHours(23, 59, 59, 999); // Set to end of today
      this.maxDate = today;
    }
  }
}
